module.exports = __webpack_public_path__ + "img/img_xinshou_2.5bccfeee.png";